<div class="selector" [class.selector--horizontal]="horizontal" [class.selector--light-background]="lightBackground">
    <div *ngFor="let language of languages" class="selector__option" [class.selector__option--selected]="language === currentLanguage"
         (click)="setLanguage(language)">
        <div class="selector__option__text">{{ language }}</div>
    </div>
</div>
